import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import './UsersDisputeIndex.scss';
import DisputeInfoList from "../../user/list/DisputeInfoList";
import DisputeHistoryList from "../../user/list/DisputeHistoryList";
import ReviewInfoList from "../../user/list/ReviewInfoList";
import ReviewHistoryList from "../../user/list/RefundHistoryList";


function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div p={3}>
          <Typography component="div">{children}</Typography>
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  tabBar: {
    backgroundColor: 'transparent',
    color: 'white',
    boxShadow: 'none',
  },
}));

export default function SimpleTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { data } = props.admin.tip;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(()=>{
      //const { token } = props.auth;
      //props.getCDKReviewRecords(1,',', '{}', false, token,0);
  },[])

  return (
    <div className={`dispute-order-tab-container ${classes.root}`}>
      <AppBar position="static" className={classes.tabBar}>
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label={`Dispute Order Handling${data&&data.user&&data.user.disputeCount?'('+data.user.disputeCount+')':''}`} {...a11yProps(0)}/>
          <Tab label="Dispute Order Record" {...a11yProps(1)} />
          <Tab label={`Pending Order For Review${data&&data.user&&data.user.reviewCount?'('+data.user.reviewCount+')':''}`} {...a11yProps(2)} />
          <Tab label="Refund Order Record" {...a11yProps(3)} />

        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <DisputeInfoList {...props}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DisputeHistoryList {...props}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ReviewInfoList {...props}/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ReviewHistoryList {...props}/>
      </TabPanel>

    </div>
  );
}
